import React from 'react';

const UnitRegButtons = ({ unit_status = 'OFF', reg_status = 'OFF' }) => {
  return (
    <div className="flex">
      {/* Unit Button */}
      <button
        className={`unit-btn px-3 py-1 text-sm rounded-l-full border-r-2 ${
          unit_status === 'ON' ? 'bg-violet-400 text-white' : 'bg-gray-400 text-white'
        } hover:bg-gray-600 focus:outline-none transition duration-200`}
      >
        Unit
      </button>

      {/* Reg Button */}
      <button
        className={`reg-btn px-3 py-1 text-sm rounded-r-full ${
          reg_status === 'ON' ? 'bg-violet-400 text-white' : 'bg-gray-400 text-white'
        } hover:bg-gray-600 focus:outline-none transition duration-200`}
      >
        Reg
      </button>
    </div>
  );
};

export default UnitRegButtons;
